import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GraphService } from './graph.service';

@Injectable({
  providedIn: 'root',
})
export class AventuraService {
  constructor(
    private http: HttpClient,
    private queryGQL: GraphService,
  ) {}

  getProperty(property: any) {
    return property;
  }

  getAllFiles() {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query{
           getAllFiles{
          id,
          paxQuantity,
          fileNumber,
          fileName,
          estadoFile,
          nameClient,
          updatedAt,
          createdAt,

          itinerarios{
            services  {
              id,
              estadoReserva,
              estadoOS,
              pagoTesoreria,

               cantPersonal,
               numOS,
                costo,
                day,
                lstPaX {
                  flightIds
                  Pax
                  estado
                  grupo
                  grupoId
                  acumulado
                  paxMenu {
                    menu {
                      id
                      nombreMenu
                    }
                    observaciones
                  }
                  type
                  passengerId
                }
                margen,
                price,
                tipoMoneda,
                totalPriceDolares,
                totalPriceSoles,
                utilidad,

              serviceId,
              productId,
              providerId,
              tarifaId,
              nombreServicio,
              tipoServicio,
              isDeleted

            }
          }

        }
      }`,
      variables: {},
    });
  }

  getOSByNumber(numberOS: string) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query getOSByNumber($numberOS:String!){
           getOSByNumber(numberOS:$numberOS){
            id
            idItinerary
            numberOS
            nameEmpresa
            nameClient
            numberFile
            group
            nameProveedor
            razonSocialProveedor


            codigoReserva
            updatedAt
            createdAt
            estadoOS
            pagoTesoreria,

            servicio{
              fechaOperacion
             fechaPago
             idServicio
             servicio
             cantPax
             monto
             moneda
             incluye
             observaciones

           }
            totalGeneral
            igv
            subTotal
            fechaProceso
            codigoReserva
        }
      }`,
      variables: { numberOS },
    });
  }

  getPdfOs(id: string) {}

  servicesByCantPersonal(id: String) {
    return this.queryGQL.queryGraphQLSales<any>({
      query: `query servicesByCantPersonal($id:String!){
        servicesByCantPersonal(id:$id)
      }
      `,
      variables: { id },
    });
  }

  getAllServices() {
    return this.queryGQL.queryGraphQL<any>({
      query: `query{
        getAllFiles{
          id,
          paxQuantity,
          lstPaX,
          services{
            idProducto,
            producto{
              id,
              nombre,
              categoriaProducto,
              fechaEntrega,
              cocineros{
                id,
                nombre
              },
               asistenteCocina{
                id,
                nombre
              },
               jefePorteador{
                id,
                nombre
              }
              porterosQuantity,
              comunidad,
               jefeArriero{
                id,
                nombre
              }
              carperosQuantity,
              acemCargaQuantity,
              acemSillaQuantity,
              arrieroQuantity,
              fechaTermino,
               tourConductor{
                id,
                nombre
              },
               asistente{
                id,
                nombre
              },
               guiaTrad{
                id,
                nombre
              },
               guiaBike{
                id,
                nombre
              },
               asisBike{
                id,
                nombre
              },
               pax{
                id,
                firstName,
                lastName
              }
            }

          }
        }
      }`,
      variables: {},
    });
  }

  getAllServicesSourcing() {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query{
         getAllServices{
            id,
            nombreServicio,
            tipoServicio,
            categoriaServicio,
            servicioProveedorId,
            searchTipoProveedor,
            proveedorNombre,
            tipoServicio
            proveedor{
              id
            },
            tarifa{
              id
            }
          }
      }`,
      variables: {},
    });
  }

  getAllProviderSourcing() {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query{
         getAllProvider{
            id,
            tipoProveedor,
            nombre,

          }
      }`,
      variables: {},
    });
  }

  getAllProveedoresByType(tipo: String) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getAllProviderByType($tipo:String!){
        getAllProviderByType(tipo:$tipo){
            id,
            locacion,
            tipoProveedor,
            nombre,
            categoriaProveedor,
            direccionLegal,
            fechasOcupadas{
              fechaInicio
              fechaFin
              itineraryId
              productId
              productName
              fileNumber
              categoriaServicio
            }
            personalCampoInfo{
              comunidad
            },
            contactos{
              contactoCelular
              contactoCorreo
            }
        }
      }
      `,
      variables: { tipo },
    });
  }

  getAllServicesByTypeAndProvider(
    tipo: String,
    categoria: string,
    id: String,
    locacion: string,
    dateVigencia: any,
  ) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getAllServicesByTypeAndProvider($tipo:String!,$categoria:String!, $id:String!, $locacion:String!,  $dateVigencia:DateVigenciaInput!){
        getAllServicesByTypeAndProvider(tipo:$tipo, categoria:$categoria, id:$id, locacion:$locacion, dateVigencia:$dateVigencia){
          id,
          nombreServicio,
          tipoServicio,
          categoriaServicio,
          locacion,
          servicioProveedorId,
          proveedor{
            id
            nombre
          },
          tarifa{
            id
            tarifaDia
            utilidad
            
            tipoTarifa
            monedaTarifa
            paxTarifa
            tipoPax
            precioPasajeroRango {
              id
              value
            }

          }
        }
      }
      `,
      variables: { tipo, categoria, id, locacion, dateVigencia },
    });
  }

  getAllServicesByType(
    tipo: String,
    categoria: string,
    dateVigencia: any,
    hasItinerary?: boolean,
  ) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getAllServicesByType($tipo:String!,$categoria:String!, $dateVigencia:DateVigenciaInput!, $hasItinerary: Boolean){
        getAllServicesByType(tipo:$tipo, categoria:$categoria,dateVigencia:$dateVigencia, hasItinerary :$hasItinerary){
          id,
          nombreServicio,
          tipoServicio,
          categoriaServicio
          locacion
          servicioProveedorId
     
          tarifa{
            id
            tarifaDia
            utilidad
            
            tipoTarifa
            monedaTarifa
            paxTarifa
            tipoPax

          }
        }
      }
      `,
      variables: { tipo, categoria, dateVigencia, hasItinerary },
    });
  }

  getProductById(id: String) {
    return this.queryGQL.queryGraphQLProduct<any>({
      query: `query getProductById($id:String!){
        getProductById(id:$id){
          id,
          categoriaProducto,
          nombre,
          subCategoriaProducto
        }
      }
      `,
      variables: { id },
    });
  }

  getServiceById(id: String) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getServiceById($id:String!){
        getServiceById(id:$id){
          id,
          categoriaServicio,
          servicioTransporteInfo{
            tipoDeUnidad,
            tipoDeTren,
            locacionInicio,
            marcaUnidad,

          }
          proveedor{
            nombre
          }

        }
      }
      `,
      variables: { id },
    });
  }

  getProvider(id: String) {
    return this.queryGQL.queryGraphQLSourcing<any>({
      query: `query getProvider($id:String!){
        getProvider(id:$id){
          id,
          nombre
          tipoProveedor
          razonSocial
        }
      }
      `,
      variables: { id },
    });
  }

  updateServicesWithPersonalCampo(params: any): Observable<any> {
    return this.queryGQL.mutateGraphQL<any>({
      mutation: `mutation updateServicesWithPersonalCampo($params: FileInput!){
         updateServicesWithPersonalCampo(params:$params){
          id,

        }
      }`,
      variables: { params },
    });
  }

  getServicesPXRByProductId(id: String) {
    return this.queryGQL.queryGraphQLProduct<any>({
      query: `query getServicesByProductId($id:String!){
        getServicesByProductId(id:$id){
          id,
          idServicio,
          createdAt,
          updatedAt,
          nombreServicio,
          nroPersonasPax{
            numPax,
            id
          }

        }
      }
      `,
      variables: { id },
    });
  }

  getAllEquipos(): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query{
         getAllEquipos{
  id,
      nombreEquipo,
      marcaEquipo,
      modeloEquipo,
      tallaEquipo,
      valoracionEquipo,
      observacionEquipo,
      cantidad,
      costo,
      categoria
      estado
          }
      }`,
      variables: {},
    });
  }

  updateFileEquipos(id: String, equipos: any): Observable<any> {
    return this.queryGQL.mutateGraphQLSales<any>({
      mutation: `mutation updateItineraryEquipos($id:String!, $equipos: [inputEquipo_Dto!]!){
        updateItineraryEquipos(id:$id, equipos: $equipos){
          id
        }
      }`,
      variables: { id, equipos },
    });
  }

  deleteEquipo(id: String): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation deleteEquipo($id: String!){
        deleteEquipo(id: $id){
          id,
        }
      }`,
      variables: { id },
    });
  }

  getEquipo(id: String): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getEquipo($id:String!){
        getEquipo(id:$id){
            id,
            factura{
            razonSocial,
            ruc,
            numFactura
            },
            nombreEquipo,
            marcaEquipo,
            modeloEquipo,
            valoracionEquipo,
            observacionEquipo,
            tallaEquipo,
            costo,
            categoria
        }
      }`,
      variables: { id },
    });
  }

  createEquipo(equipo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation createEquipo($equipo: inputEquipo_Dto!){
        createEquipo(equipo: $equipo){
          id,
          nombreEquipo,
          categoria,
          marcaEquipo,
          tallaEquipo,
          modeloEquipo,
          valoracionEquipo,
          observacionEquipo
        }
      }`,
      variables: { equipo },
    });
  }

  updateIngreso(id: String, almacenInsumo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateIngreso($id:String!, $almacenInsumo: inputAlmacen_Dto!){
        updateIngreso(id:$id, almacenInsumo: $almacenInsumo){
             id,
          factura{
            razonSocial,
            ruc,
            numFactura
          },
          locacion,
          fechaEntrada,
          detalleInsumos{
            id,
            nombreInsumo,
            unidadMedida,
            cantidad,
            costo,
            categoria
          }
        }
      }`,
      variables: { id, almacenInsumo },
    });
  }

  updateEquipo(id: String, equipo: any): Observable<any> {
    return this.queryGQL.mutateGraphQLAlmacen<any>({
      mutation: `mutation updateEquipo($id:String!, $equipo: inputEquipo_Dto!){
        updateEquipo(id:$id, equipo: $equipo){
          nombreEquipo,
          categoria,
          marcaEquipo,
          tallaEquipo,
          modeloEquipo,
          valoracionEquipo,
          observacionEquipo
        }
      }`,
      variables: { id, equipo },
    });
  }

  addFechasOcupadas(providerId: any, fechasOcupadas: any): Observable<any> {
    return this.queryGQL.mutateGraphQLSoucing<any>({
      mutation: `mutation addFechasOcupadas($providerId: String!,$fechasOcupadas: inputFechasOcupadas_Dto!){
        addFechasOcupadas(providerId:$providerId,fechasOcupadas:$fechasOcupadas)
      }`,
      variables: { providerId, fechasOcupadas },
    });
  }

  deleteFechasOcupadas(providerId: any, fechasOcupadas: any): Observable<any> {
    return this.queryGQL.mutateGraphQLSoucing<any>({
      mutation: `mutation deleteFechasOcupadas($providerId: String!,$fechasOcupadas: inputFechasOcupadas_Dto!){
        deleteFechasOcupadas(providerId:$providerId,fechasOcupadas:$fechasOcupadas)
      }`,
      variables: { providerId, fechasOcupadas },
    });
  }

  getAllAgrupadoByFile(itineraryId: String): Observable<any> {
    return this.queryGQL.queryGraphQLAlmacen<any>({
      query: `query getAllAgrupadoByFile($itineraryId:String!){
        getAllAgrupadoByFile(itineraryId:$itineraryId){
          id
          productId
          agrupadoId
          selected
          itineraryId
          agrupadoInfo{
            equipoId
            nombreEquipo
            marcaEquipo
            pesoEquipo
            modeloEquipo
            nroPersonasPax
          }
        }
      }`,
      variables: { itineraryId },
    });
  }
}
